export const cubicTransition = 'cubic-bezier(.03,.98,.52,.99)';
